import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, shareReplay, tap } from 'rxjs';
import { User } from '@app/shared/models';
import { appActions } from '@app/core/store/app.actions';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { RoleFunctionName } from '@app/core/enums/role-function-name.enum';
import { AccessMatrixLevel } from '@app/core/enums/access-settings.enums';
import { RoleName } from '@app/shared/enums';

interface UserResponse extends Omit<User, 'functionNames'> {
  functionNames: {
    functionName: RoleFunctionName;
    accessLevel: AccessMatrixLevel;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private httpClient: HttpClient,
    private store: Store
  ) {}

  public getUser(): Observable<User> {
    return this.httpClient
      .get<UserResponse>(`${environment.accountApi}/user`)
      .pipe(
        // todo: remove first map after change roles
        map(user => {
          if (user.isApprover) {
            const newTemporaryRole = { name: RoleName.Approver };
            return { ...user, roles: [...user.roles, newTemporaryRole] };
          }
          return user;
        }),
        map(user => this.transformUser(user)),
        tap(user => {
          this.store.dispatch(appActions.setUser({ user }));
        }),
        shareReplay(1)
      );
  }

  private transformUser(user: UserResponse): User {
    return {
      ...user,
      functionNames: user.functions?.reduce(
        (acc, { functionName, accessLevel }) => {
          acc[functionName] = accessLevel;
          return acc;
        },
        {} as Record<RoleFunctionName, AccessMatrixLevel>
      )
    };
  }
}
